import type { IContentCategoriesState } from './types';
import { types } from './types';

export const initialState: IContentCategoriesState = {
    catalog: null,
    fetching: false,
    error: null,
};

export function contentCategoriesReducer(state = initialState, action: any): IContentCategoriesState {
    switch (action.type) {
        case types.FETCH:
            return { ...state, fetching: true, error: null };
        case types.FETCH_SUCCESS:
            return { ...state, fetching: false, catalog: action.payload };
        case types.FETCH_FAIL:
            return { ...state, fetching: false, error: action.payload };
        case types.CLEAR:
            return { ...initialState };
        default:
            return state;
    }
}
